<template>
    <base-side-bar>
        <div class="flex flex-col items-center justify-center w-full mx-10">
            <h2
                class="font-extrabold leading-9 text-center text-blue-600 text-xxxl sm:text-xl sm:leading-10"
            >
                Moyens d'exploitation
            </h2>
            <br />
            <div class="flex flex-col items-center justify-center w-full">
               <!--   <wide-card>
                    <base-tips-alert>
                        <p class="my-0 mt-1 text-gray-700">
                            Veillez à ne pas « sous-dimensionner » ou «
                            sur-dimensionner » votre projet sur le plan moyens
                            d'exploitation.
                        </p>
                    </base-tips-alert>
                </wide-card>-->
                <template v-if="!isSimplifiedVersion">
                    <base-steps :steps="steppers" />
                </template>

                <InfoMessage />

                <router-view v-on:showNotification="showNotification" />
            </div>
        </div>
    </base-side-bar>
</template>

<script>
import WideCard from "../../../components/cards/wideCard";
import InfoMessage from "./moyen_dexploitation/components/InfoMessage";
import { mapState, mapGetters } from "vuex";
export default {
    components: {
        WideCard,
        InfoMessage
    },
    data() {
        return {};
    },
    created() {
        this.$store.dispatch("forms/showSection", "Étude Technique");
        this.$store.dispatch("forms/stepFocus", "Moyens d’exploitation");
    },
    computed: {
        ...mapGetters("user", {
            isSimplifiedVersion: "isSimplifiedVersion"
        }),
        ...mapState("forms", {
            steppers: state => state.steppers
        })
    },
    methods: {
        showNotification(notification) {
            this.$emit("showNotification", notification);
        }
    }
};
</script>

<style></style>
